import { publicUrlFor } from "../../../../globals/constants";
import { NavLink } from "react-router-dom";

function SectionVideo3({ _data }) {
  return (
    <>
      <div className="section-full sx-video-2-outer" style={{ backgroundImage: `linear-gradient(rgba(10, 15, 24, 0.6), rgba(10, 15, 24, 0.6)), url(${publicUrlFor(_data.background)})` }}>
        <div className="container">
          <div className="sx-vodeo-section text-center">
            <div className="sx-video-btn-wrap">
              <NavLink to="/contact-us" className="circle">
                <i className="flaticon-incoming-call" />
              </NavLink>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default SectionVideo3;
